import { lists } from '@/api'
import { getUserPlayersWithStats, getOtherPlayersWithStats } from '@/services/utils'
import axios from 'axios'

const getData = (context, id) => {
  return new Promise((resolve, reject) => {
    const Promises = [
      lists.count(id),
      lists.fetchUserOne(id),
      lists.fetchTemplate(id)
    ]

    axios.all(Promises)
      .then(responses => {
        lists.fetchStats(responses[1].data.templateId)
          .then(stats => {
            const userPlayers = getUserPlayersWithStats(responses[1].data._sections, stats.data._players)
            context.commit('TEMPLATE_UPDATED', responses[2].data.id)
            context.commit('COUNT_UPDATED', responses[0].data.count)
            context.commit('TEMPLATE_PLAYERS_UPDATED', getOtherPlayersWithStats(responses[2].data._sections, userPlayers, stats.data._players, responses[0].data.count))
            context.commit('USER_PLAYERS_UPDATED', userPlayers)
            context.commit('STATS_UPDATED', userPlayers)
            resolve('success')
          }, error => {
            console.log(error)
            reject(error)
          })
      }, error => {
        console.log(error)
      })
  })
}

export default {
  getData
}



// WEBPACK FOOTER //
// ./src/store/modules/results/actions.js